import { useDisplayOptionContext } from "./useDisplayOptionContext";
import { useGetFacilitiesV2Query } from "@/features/api/apiSlice";

export const useFacilities = () => {
    const { facilityIds } = useDisplayOptionContext();
    const { data, isLoading, isSuccess, isError, error } =
        useGetFacilitiesV2Query({
            ids: facilityIds.join(","),
            withSettings: true,
        });

    return {
        facilities: data?.data || [],
        isLoading,
        // True once the query has settled (success or error). Distinct from
        // !isLoading, which is also true on the uninitialized first render
        // before the request dispatches — the window that flashed the fallback.
        isResolved: isSuccess || isError,
        error,
    };
};